import React, { useContext } from "react";

import { ServerCachesMetricsContextType } from "./types";

export const ServerCachesMetricsContext =
  React.createContext<ServerCachesMetricsContextType>(null);

export const useServerCachesMetricsContext = () =>
  useContext(ServerCachesMetricsContext);
